import { render, staticRenderFns } from "./ContentOptions.vue?vue&type=template&id=1a0797c0&"
import script from "./ContentOptions.vue?vue&type=script&lang=js&"
export * from "./ContentOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports